export default __webpack_public_path__ + "static/reflection-cd772e24e0fdcd16cf3e606a6214fc7f.webp";